import { useState } from 'react';
import { RegisterData } from '../../../../type/register-data';
import { ActiveBlock } from '../enum/active-block';

export function useViewModel() {
  const [activeBlock, setActiveBlock] = useState<ActiveBlock>(ActiveBlock.FORM);
  const [phone, setPhone] = useState<string | null>(null);

  const registerFormSubmitHandler = (data: RegisterData) => {
    setActiveBlock(ActiveBlock.COMPLETE);
    setPhone(data.phone);
  };

  return {
    activeBlock,
    registerFormSubmitHandler,
    phone,
  };
}
